import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { getFileExtension, getFileIconName } from '@platform/shared/utilities/file-utility';
import { FormGroup } from '@angular/forms';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-mobile-upload-file-preview',
  templateUrl: './mobile-upload-file-preview.component.html',
  styleUrls: ['./mobile-upload-file-preview.component.scss'],
})
export class MobileUploadFilePreviewComponent implements OnInit, OnDestroy {
  @Input() file: File;
  @Input() formGroup: FormGroup;
  @Input() fileExtension: string;
  @Input() inputName: string;
  imageUrl: SafeUrl | null = null;
  fileIcon: string;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.imageUrl = this.createImageUrl(this.file);
    this.fileIcon = getFileIconName(getFileExtension(this.file.name));
    this.formGroup.valueChanges.pipe(tap((c) => console.log(c)));
  }

  ngOnDestroy(): void {
    this.destroyImageUrl(this.imageUrl);
  }

  private createImageUrl(file: File): SafeUrl | null {
    if (/^image\/.*$/.test(file.type)) {
      const url = URL.createObjectURL(file);
      return this.domSanitizer.bypassSecurityTrustUrl(url);
    }

    return null;
  }

  private destroyImageUrl(fileUrl: SafeUrl | null) {
    if (fileUrl) {
      URL.revokeObjectURL(fileUrl as string);
    }
  }
}
